import { newE2EPage } from "@stencil/core/testing";

describe("ux-input-label", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(template());
        const el = await page.find("ux-input-label");
        expect(el).toHaveClass("hydrated");
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(template());
        const el = await page.find("ux-input-label");
        expect(el).toMatchSnapshot();
    });

    it("should match to snapshot with error", async () => {
        const page = await newE2EPage();
        await page.setContent(template(true));
        const el = await page.find("ux-input-label");
        expect(el).toMatchSnapshot();
    });
});

function template(withError = false) {
    return `
        <ux-input-label 
            text="label"
            label-classes="ux-u-text-uppercase"
            label-id="1"
            input-id="2"
            required
            label-info="label-info"
            ${!withError ? `` : `error error-msg="error"`}
        >
            <ux-icon name="globe" weight="normal"></ux-icon>
        </ux-input-label>
    `;
}
